import { Component, Input, OnInit } from '@angular/core';
import { LocalizationService, ScreenDetectedService } from '@core/services';
import { BtnTypeColor } from '@enums';

@Component({
  selector: 'bz-static-footer',
  templateUrl: './static-footer.component.html',
  styleUrls: ['./static-footer.component.sass']
})
export class StaticFooterComponent implements OnInit {
  public colors: typeof BtnTypeColor = BtnTypeColor;
  public arr = Array;
  public dataStatic: any[] = [];
  @Input() public showCopyright: boolean = false;
  @Input() public setAbsoluteProperty: boolean = true;
  @Input() public isPharmaciesPage: boolean = false;
  @Input() public isSearchPage: boolean = false;

  constructor(
    private localize: LocalizationService,
    public screen: ScreenDetectedService
  ) { }

  public ngOnInit(): void {
    this.dataStatic = [
      {
        elem: [
          {
            img: 'statics_voz.webp',
            title: 'footer.voz.title',
            color: this.colors.second,
            text: 'footer.voz.description'
          },
          {
            img: 'statics_podkl.webp',
            title: 'footer.connect.title',
            color: '#53a8de',
            text: 'footer.connect.description'
          },
          {
            img: 'phone-icon.svg',
            title: 'footer.version.app.mobile',
            color: '#53a8de',
            text: ' ',
            isEmpty: true
          }
        ]
      },
      {
        elem: [
          {
            img: null,
            title: 'mobile.app.text',
            color: '',
            text: this.screen.isDesktop() && !this.isPharmaciesPage ? [] : ['google.play', 'app.store'],
            isButtons: true
          },
          {
            img: null,
            title: 'footer.users.title',
            color: '',
            text: this.screen.isDesktop() ? ['confidentiality',
              'agreement',
              'catalog',
              'payment.receipt',
              'reserving'
            ]
              : ['confidentiality',
                'agreement',
                'catalog',
                'payment.receipt',
                'reserving'
              ]
          }, {
            img: null,
            title: 'footer.version.mobile.title',
            color: '',
            text: ['footer.version.cite.map']
          }, {
            img: null,
            title: 'footer.partners.title',
            color: '',
            // 'footer.partners.private', 'footer.partners.advertisers', 'footer.partners.conditions'
            text: this.screen.isDesktop() ?
              [
                'footer.partners.connect',
                // 'certificates'
              ] : [
                'footer.partners.connect',
                // 'certificates'
              ]
          }, {
            img: null,
            title: 'footer.about.us.title',
            color: '',
            // 'footer.about.us.tech'
            text: this.screen.isDesktop() ? [
              'footer.about.company',
              'footer.about.us.devs',
              'page.smi',
              'page.contact',
              'irresponsible',
              'grant.page',
              'licenses',
            ] : [
              'footer.about.company',
              'footer.about.us.devs',
              'page.smi',
              'page.contact',
              'irresponsible',
              'grant.page',
              'licenses',
            ]
          }]
      }
    ];
  }

  public goToPage(page: string): string {
    switch (page) {
      case 'confidentiality': return this.localize.getRouterLinkApp('confidentiality');
      case 'agreement': return this.localize.getRouterLinkApp('agreement');
      case 'page.contact': return this.localize.getRouterLinkApp('contacts');
      case 'payment.receipt': return this.localize.getRouterLinkApp('delivery');
      case 'catalog': return this.localize.getRouterLinkApp('catalog');
      case 'footer.version.cite.map': return this.localize.getRouterLinkApp('sitemap');
      case 'footer.about.company': return this.localize.getRouterLinkApp('about-company');
      case 'footer.about.us.devs': return this.localize.getRouterLinkApp('team');
      case 'footer.partners.connect': return this.localize.getRouterLinkApp('connect');
      case 'certificates': return this.localize.getRouterLinkApp('certificates');
      case 'page.smi': return this.localize.getRouterLinkApp('references');
      case 'reserving': return this.localize.getRouterLinkApp('reserving');
      case 'irresponsible': return this.localize.getRouterLinkApp('irresponsible');
      case 'grant.page': return this.localize.getRouterLinkApp('grant');
      case 'licenses': return this.localize.getRouterLinkApp('licenses');
      case 'alphabetical': return this.localize.getRouterLinkApp('alphabetical');
    }
  }

}
